export default {
  id: 'GuardianComponent',
  code: 'CN',
  text: {
    'Guardian Name': '家长姓名',
    'Guardian Email': '家长邮箱',
    'Guardian can use phone number to sign up and log in mobile app': '家长将可以使用手机号注册登录手机 app',
    'Relationship': '亲属关系',
    '': '',
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Guardian/locale.js